import React from 'react';
import styled from 'styled-components';
import {
  cssColorValue,
  screenMdMin,
  screenXlMin,
  screenXsMin,
  semanticColors,
  spacer16,
  spacer20,
  spacer4,
  spacer40,
  spacer48,
} from '@spotify-internal/encore-web';

import { useVerticalConfig } from 'providers/vertical';

import { verticalMasthead } from '../constants';

import { NavBarLogo } from './Logo';
import { NavBarLinks } from './Links';
import { NavBarSecondaryLinks } from './SecondaryLinks';
import { NavBarSideMenuWrapper } from './SideMenuWrapper';

const NavBarWrapper = styled.header`
  align-items: center;
  box-sizing: border-box;
  background: ${cssColorValue(semanticColors.backgroundBase)};
  color: ${cssColorValue(semanticColors.textBase)};
  display: flex;
  justify-content: space-between;
  padding-block: ${spacer20};
  padding-inline: ${spacer40};
  position: relative;
  width: 100%;
  z-index: 1000;

  @media (max-width: ${screenMdMin}) {
    padding-block: ${spacer4};
    transition: transform 400ms ease-in-out;
    -webkit-transition: -webkit-transform 400ms ease-in-out;
  }

  @media (max-width: ${screenXsMin}) {
    padding-inline: ${spacer16};
  }

  @media (min-width: 1440px) {
    padding-inline: ${spacer48};
  }

  @media (min-width: ${screenXlMin}) {
    padding-inline: ${spacer48};
  }
`;

export const TurnkeyNavBar = () => {
  const { verticalName } = useVerticalConfig();
  const mastheadConfig = verticalMasthead[verticalName];

  if (mastheadConfig) {
    const { header: headerEntry, languageSelection: languageSelectionEntry } = mastheadConfig.linksConfig;
    return (
      <NavBarWrapper className={mastheadConfig.colorSet} role="banner">
        <NavBarLogo headerEntry={headerEntry} />
        <NavBarLinks headerEntry={headerEntry} />
        <NavBarSecondaryLinks headerEntry={headerEntry} languageSelectionEntry={languageSelectionEntry} />
        <NavBarSideMenuWrapper headerEntry={headerEntry} languageSelectionEntry={languageSelectionEntry} />
      </NavBarWrapper>
    );
  }

  return null;
};
